import { Button, ButtonWithIcon, FiltersModal, Label } from '@blueprint/ui';
import { css } from '@emotion/css';
import emotionStyled from '@emotion/styled';
import { styled } from '@zoopla-eng/zds-components/themes';

export const SelectWrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '$S100',
    position: 'relative'
});

export const StyledLabel = styled('label', {
    fontWeight: '$400',
    fontGroup: 'ladle',
    color: '$textBody'
});

export const StyledSelect = styled('select', {
    appearance: 'none',
    color: '$textBody',
    fontGroup: 'ladle',
    textAlign: 'left',
    display: 'flex',
    columnGap: '$S200',
    bg: '$graphicBackgroundDefault',
    height: '$L200',
    p: '$S300',
    border: '$borderWidths$100 solid $inputBorderDefault',
    borderRadius: '$300',
    '&:focus': {
        focusRing: '$functionalFocus'
    },
    '&:hover:enabled': {
        borderColor: '$inputBorderHover'
    },
    '&:active:enabled': {
        borderColor: '$inputBorderActive'
    },
    width: '100%'
});

export const IconContainer = styled('div', {
    position: 'absolute',
    bottom: '$S300',
    right: '$S300',
    pointerEvents: 'none',
    width: '24px',
    height: '24px'
});

// Legacy Emotion
export const FiltersLabel = emotionStyled(Label)(
    ({ theme: { spacing, colors } }) => css`
        padding: 0 0 ${spacing['8px']} 0;
        margin-top: ${spacing['24px']};
        display: block;
        margin-bottom: 0;
        color: ${colors['text-body']};
    `
);

export const DesktopFiltersButtonWrapper = emotionStyled('div')(
    ({ theme: { spacing } }) => css`
        display: flex;
        z-index: 3;
        height: ${spacing['48px']};
        background-color: white;
    `
);

type StyledButtonProps = {
    isDisabled?: boolean;
};

export const UpdateButton = emotionStyled(Button)<StyledButtonProps>(
    ({ isDisabled = false }) => css`
        opacity: ${isDisabled ? 0.4 : 1};
        cursor: ${isDisabled ? 'default' : 'pointer'};
    `
);

export const FiltersContainer = emotionStyled.div(
    ({ theme: { mq, spacing } }) => css`
        height: 100%;
        width: 100%;
        max-width: inherit;

        ${mq.small} {
            height: calc(100% - ${spacing['48px']});
            overflow: hidden;
        }
        ${mq.large} {
            height: 100%;
        }
    `
);

export const StyledFiltersModal = emotionStyled(FiltersModal)(() => css``);

export const MobileFiltersButton = emotionStyled(ButtonWithIcon)(
    ({ theme: { spacing } }) => css`
        padding: ${spacing['4px']} 1.3125rem ${spacing['4px']} 1.3125rem;
        min-width: unset;
    `
);

const LSRP_SIDEBAR_MEDIA_QUERY = `@media only screen and (min-width: 1140px)`;

export const DesktopFiltersButton = emotionStyled(ButtonWithIcon)(`
    display: none;

    ${LSRP_SIDEBAR_MEDIA_QUERY} {
        display: flex;
    }
`);
